export const TAGS = [
    {
        name: 'Hàng tặng',
        value: 'gift'
    },
    {
        name: 'Hàng mẫu',
        value: 'sample'
    },
    {
        name: 'FBA',
        value: 'FBA'
    },
    {
        name: 'Ship nhanh',
        value: 'fastship'
    },
    {
        name: 'UIDSAMPLE',
        value: 'UIDSAMPLE'
    },
    {
        name: 'Sản xuất nhanh',
        value: 'fastproduction'
    },
    {
        name: 'CutOff',
        value: 'cutoff'
    },
    {
        name: 'CutOff noel',
        value: 'cutoff_noel'
    },
    {
        name: 'CutOff new year',
        value: 'cutoff_new_year'
    },
    {
        name: 'HQ Gấp',
        value: 'HQ gap'
    },
    {
        name: 'TikTok',
        value: 'tiktok'
    }
]